import * as d3 from 'd3'

export default {
  methods: {

    draw_MCC(x_) {
      
      let mcc = this.canvasForms
      .append('g')
      .attr('transform', `translate(${x_}, 90)`)
      .attr('font-family', 'roboto')

      mcc
      .append('text')
      .attr('x', 0).attr('y', 12*0.35)
      .attr('font-size', 12).attr('fill', '#333')
      .text('MCC')

      mcc
      .append('rect')
      .attr('x', 0).attr('y', 8).attr('rx', 5)
      .attr('width', 120).attr('height', 125)
      .attr('fill', '#83D2F5').attr('fill-opacity', 0.075)
      .attr('stroke', '#E0E0DF').attr('stroke-wisth', .5)

      
      this.mcc.forEach((d,i)=> {

        mcc
        .append('text')
        .attr('x', 20).attr('y', (i*35) + 24 + 10*0.35)
        .attr('font-size', 10).attr('fill', '#757575')
        .text(d.name)

        mcc
        .append('rect')
        .attr('x', 20).attr('y', (i*35) + 30)
        .attr('width', 80).attr('height', 18)
        .attr('fill', '#fff').attr('stroke', '#E0E0DF').attr('stroke-wisth', .5)

        mcc
        .append('text')
        .attr('x', 60).attr('y', (i*35) + 39 + 11*0.35)
        .attr('font-size', 11).attr('fill', '#333')
        .attr('text-anchor', 'middle')
        .text(this.rawData[`MCC_${d.id}`])
      })

      
      this.canvasForms
      .append('image')
      .attr('transform', `translate(290, 170) rotate(-90)`)
      .attr('xlink:href', this.HOST + '/icon/arrow_LightGray.svg')
      .attr('x', 0).attr('y', 0).attr('width', 30).attr('opacity', .9)

      this.canvasForms
      .append('image')
      .attr('transform', `translate(455, 170) rotate(-90)`)
      .attr('xlink:href', this.HOST + '/icon/arrow_LightGray.svg')
      .attr('x', 0).attr('y', 0).attr('width', 30).attr('opacity', .9)
    },
  }
}